/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoJsonType } from './GeoJsonType';
import {
    GeoJsonTypeFromJSON,
    GeoJsonTypeFromJSONTyped,
    GeoJsonTypeToJSON,
    GeoJsonTypeToJSONTyped,
} from './GeoJsonType';

/**
 * 
 * @export
 * @interface GeoPoint
 */
export interface GeoPoint {
    /**
     * 
     * @type {GeoJsonType}
     * @memberof GeoPoint
     */
    type: GeoJsonType;
    /**
     * 
     * @type {Array<number>}
     * @memberof GeoPoint
     */
    coordinates: Array<number>;
}



/**
 * Check if a given object implements the GeoPoint interface.
 */
export function instanceOfGeoPoint(value: object): value is GeoPoint {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function GeoPointFromJSON(json: any): GeoPoint {
    return GeoPointFromJSONTyped(json, false);
}

export function GeoPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'type': GeoJsonTypeFromJSON(json['type']),
        'coordinates': json['coordinates'],
    };
}

export function GeoPointToJSON(json: any): GeoPoint {
    return GeoPointToJSONTyped(json, false);
}

export function GeoPointToJSONTyped(value?: GeoPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': GeoJsonTypeToJSON(value['type']),
        'coordinates': value['coordinates'],
    };
}

